import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ResourcesSteps from 'app/components/Resources/ResourcesSteps';
import useResourcesContent from 'app/components/Resources/hooks/useResourcesContent';
import useResourcesReset from 'app/components/Resources/hooks/useResourcesReset';
import { setPrompt } from 'store/reducers/nlp/nlp-reducer';

export default function BD100ResourceLibrary() {
  useResourcesContent();
  const resourcesResetSearch = useResourcesReset();
  const dispatch = useDispatch();

  useEffect(() => {
    const prompt = new URLSearchParams(window.location.search).get('prompt');
    resourcesResetSearch();
    if (prompt) {
      dispatch(setPrompt(prompt));
    }
  }, []);

  return <ResourcesSteps />;
}
